import { z } from 'zod'
import { oc } from '@orpc/contract'
import { AGENDA_APPOINTMENT_STATUSES, AGENDA_READINESS } from './list-appointment-agenda.contract'

export const READINESS_MAX_IDS = 50

/**
 * Cheap companion to `listAppointmentAgenda` for polling the Join gate: one Appointment
 * search by id, no joins. `readiness` is derived from Appointment.status alone (the encounter
 * is not read), so it flips upcoming → ready on check-in but cannot see an in-progress or
 * finished encounter — clients should only upgrade rows with it, and rely on the agenda
 * refresh for everything else. Ids the caller may not see, or that no longer exist, are
 * simply absent from `items`.
 */
export const getAppointmentReadiness = oc
  .route({ method: 'GET', path: '/v2/appointments/readiness' })
  .input(
    z.object({
      appointmentIds: z.array(z.string().min(1)).min(1).max(READINESS_MAX_IDS),
    }),
  )
  .output(
    z.object({
      items: z.array(
        z.object({
          appointmentId: z.string(),
          appointmentStatus: z.enum(AGENDA_APPOINTMENT_STATUSES),
          readiness: z.enum(AGENDA_READINESS),
        }),
      ),
    }),
  )
